import style from "./ListContainerWithOptions.module.css";

const ListContainerWithOptions = ({ children }) => {
    return (
        <div className={style.list_container}>{children}</div>
    );
}

export default ListContainerWithOptions;